import { ComponentType, FC, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useLocalStorage } from 'common/hooks';
import { isEmbedded } from 'common/utils';
import { useGetAccountQuery } from 'user/api';

export const withRedirectToEventFromLocalStorage =
  <Props extends object>(WrappedComponent: ComponentType<Props>): FC<Props> =>
  (props) => {
    const { data: redirectUri, removeStoredData } = useLocalStorage({ key: 'redirectUri' });
    const { pathname } = useLocation();
    const history = useHistory();
    const { isSuccess: isAccountLoaded } = useGetAccountQuery();

    useEffect(() => {
      if (isEmbedded() || !redirectUri || !isAccountLoaded) {
        return;
      }

      if (redirectUri === pathname) {
        removeStoredData();
        return;
      }

      if (pathname === '/') {
        history.replace(redirectUri);
        removeStoredData();
      }
    }, [pathname, redirectUri, history, removeStoredData, isAccountLoaded]);

    return <WrappedComponent {...(props as Props)} />;
  };
